module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  total=\"$ctrl.total\"\n  limit=\"$ctrl.limit\"\n  item-state=\"bus\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  sort-event=\"$ctrl.sortEvent\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  title=\"Buses\"\n  resource=\"Bus\"\n  transformer=\"BusesTransforms\"\n  no-items-text=\"No Buses Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/buses/buses.html
// module id = 1321
// module chunks = 0